import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { axiosClient } from '../../../core/axios-client'

const fetchPayments = createAsyncThunk(
  'payments/fetchPayments',
  async ({ filters = {} } = {}) => {
    const response = await axiosClient.get('/companies/selected/payments', {
      params: { ...filters }
    })
    return response.data
  }
)

const fetchRentPayment = createAsyncThunk(
  'payments/fetchRentPayment',
  async ({ rent_id, filters = {} } = {}) => {
    const response = await axiosClient.get(
      `/companies/selected/rents/${rent_id}/transactions`,
      {
        params: { ...filters }
      }
    )
    return response.data
  }
)

const fetchPayment = createAsyncThunk(
  'payments/fetchPayment',
  async ({ id }) => {
    const response = await axiosClient.get(`/companies/selected/payments/${id}`)
    return response.data
  }
)

const setAsPaid = createAsyncThunk(
  'payments/setAsPaid',
  async ({ id, data = {} }) => {
    const response = await axiosClient.post(
      `/companies/selected/payments/${id}/set-as-paid`,
      data
    )
    return response.data
  }
)

const setAsCanceled = createAsyncThunk(
  'payments/setAsCanceled',
  async ({ id, data = {} }) => {
    const response = await axiosClient.post(
      `/companies/selected/payments/${id}/set-as-canceled`,
      data
    )
    return response.data
  }
)

const setAsOverdue = createAsyncThunk(
  'payments/setAsOverdue',
  async ({ id }) => {
    const response = await axiosClient.post(
      `/companies/selected/payments/${id}/set-as-overdue`
    )
    return response.data
  }
)

const initialState = {
  listItems: {
    items: [],
    page: 1,
    page_size: 10,
    count: 0,
    paymentStatusFilter: 'all',
  },
  payments: [],
  payment: null
}

const resetTbankAttempt = createAsyncThunk(
  'payments/resetTbankAttempt',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        `/companies/selected/payments/${id}/reset-tbank-attempt`
      )
      return response.data
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Не удалось разблокировать оплату')
    }
  }
)

export const slice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    setListItems(state, { payload }) {
      state.listItems = {
        ...state.listItems,
        ...payload
      }
      state.payments = state.listItems.items
    },
    resetListItems(state) {
      state.listItems = {
        items: [],
        page: 1,
        page_size: 10,
        count: 0,
        paymentStatusFilter: 'all',
      }
      state.payments = []
    }
  },
  extraReducers: (builder) => {
    const applyListPayload = (state, payload) => {
      if (!payload) {
        state.listItems.items = []
        state.listItems.count = 0
        return
      }
      const { count = 0, results = null } = payload
      const items = Array.isArray(results)
        ? results
        : Array.isArray(payload)
          ? payload
          : (payload.results || [])
      state.listItems = {
        ...state.listItems,
        items,
        count
      }
      state.payments = items
    }

    builder
      .addCase(fetchPayments.fulfilled, (state, { payload }) => {
        applyListPayload(state, payload)
      })
      .addCase(fetchRentPayment.fulfilled, (state, { payload }) => {
        applyListPayload(state, payload)
      })
      .addCase(fetchPayment.fulfilled, (state, { payload }) => {
        state.payment = payload
      })
      .addCase(setAsPaid.fulfilled, (state, { payload }) => {
        state.payment = payload
      })
      .addCase(setAsCanceled.fulfilled, (state, { payload }) => {
        state.payment = payload
      })
      .addCase(setAsOverdue.fulfilled, (state, { payload }) => {
        state.payment = payload
      })
  }
})

export const { setListItems, resetListItems } = slice.actions

export {
  fetchPayments,
  fetchRentPayment,
  fetchPayment,
  setAsPaid,
  resetTbankAttempt,
  setAsCanceled,
  setAsOverdue
}

export default slice.reducer
